export enum AccountRole {
  BUSINESS_OWNER = 'BUSINESS_OWNER',
  MARKETING_ADVISOR = 'MARKETING_ADVISOR',
}

export enum AccountStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export enum TenantName {
  THA = 'tha',
}
